module.exports = __webpack_public_path__ + "static/MC_steps_reemplazo_FISICA_7_B-ca79c10e663ba0554d37dc0a65e20fa0.gif";